module.exports = __webpack_public_path__ + "static/media/SealCheck.9ba9b815.svg";